import { render, staticRenderFns } from "./ListaClientes.vue?vue&type=template&id=7f08932e&scoped=true&"
import script from "./ListaClientes.vue?vue&type=script&lang=js&"
export * from "./ListaClientes.vue?vue&type=script&lang=js&"
import style0 from "./ListaClientes.vue?vue&type=style&index=0&id=7f08932e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08932e",
  null
  
)

export default component.exports